/* ============================================================
   MISS JO — CUSTOM OVERRIDES
   File: assets/custom-overrides.js
   Called from: theme.liquid just before </body>
   ============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     UTILITY: Wait for custom element to be defined
  ────────────────────────────────────────────────────────── */
  function whenDefined(tagName, callback) {
    if (window.customElements) {
      window.customElements.whenDefined(tagName).then(callback);
    }
  }

  /* ──────────────────────────────────────────────────────────
     UTILITY: Inject a <style> tag into <head> (once only)
  ────────────────────────────────────────────────────────── */
  function injectCSS(id, rules) {
    if (document.getElementById(id)) return;
    var el = document.createElement('style');
    el.id = id;
    el.textContent = rules;
    document.head.appendChild(el);
  }

  /* ──────────────────────────────────────────────────────────
     FIX 1: MENU DRAWER CLOSE BUTTON
     button[part="close-button tap-area"] inside header-sidebar
     shadow DOM fires dialog:force-close but stopPropagation()
     in DialogElement kills it before HeaderSidebar.hide() runs.
     Fix: capture-phase delegation → walk shadow host chain →
     call .hide() directly on the right element.
  ────────────────────────────────────────────────────────── */
  whenDefined('header-sidebar', function () {
    document.addEventListener('click', function (e) {
      var path = e.composedPath ? e.composedPath() : [];
      var closeBtn = null;

      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || el.nodeType !== 1) continue;
        var part = el.getAttribute ? el.getAttribute('part') : '';
        if (part && part.indexOf('close-button') !== -1) {
          closeBtn = el;
          break;
        }
      }

      if (!closeBtn) return;

      var hosts = ['header-sidebar', 'header-search', 'x-modal', 'x-drawer'];
      var node = closeBtn;
      var target = null;

      while (node) {
        node = node.parentElement
          || (node.getRootNode && node.getRootNode().host)
          || null;
        if (!node || !node.tagName) continue;
        if (hosts.indexOf(node.tagName.toLowerCase()) !== -1) {
          target = node;
          break;
        }
      }

      if (target && typeof target.hide === 'function') {
        e.stopImmediatePropagation();
        target.hide();
      }
    }, true);
  });

  /* ──────────────────────────────────────────────────────────
     FIX 2: SEARCH MODAL CLOSE BUTTON
     <dialog-close-button> fires dialog:force-close with
     composed:true but DialogElement swallows it.
     Fix: same capture-phase approach targeting header-search.
  ────────────────────────────────────────────────────────── */
  whenDefined('header-search', function () {
    document.addEventListener('click', function (e) {
      var path = e.composedPath ? e.composedPath() : [];
      var isCloseBtn = false;

      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.tagName && el.tagName.toLowerCase() === 'dialog-close-button') {
          isCloseBtn = true;
          break;
        }
      }

      if (!isCloseBtn) return;

      var targets = ['header-search', 'x-modal', 'x-drawer'];
      for (var j = 0; j < path.length; j++) {
        var host = path[j];
        if (!host || !host.tagName) continue;
        if (targets.indexOf(host.tagName.toLowerCase()) !== -1) {
          if (typeof host.hide === 'function') {
            e.stopImmediatePropagation();
            host.hide();
          }
          return;
        }
      }
    }, true);
  });

  /* ──────────────────────────────────────────────────────────
     FIX 3: SEARCH BAR — PREVENT HEADER ROW WRAPPING
  ────────────────────────────────────────────────────────── */
  injectCSS('mj-header-fix', [
    '.header__search{flex-shrink:0!important;}',
    '.header__icon-list{flex-wrap:nowrap!important;}',
    'header-search{flex-shrink:0!important;}',
  ].join(''));

  /* ──────────────────────────────────────────────────────────
     FIX 4: SEARCH DIALOG POSITION — STICKY HEADER
     
     Root cause: header-search lives inside .shopify-section
     wrapper which has a CSS transform applied. position:fixed
     on a child of a transformed element positions relative to
     that ancestor, not the viewport — so top:58px renders
     at wrong position.
     
     Fix: Move header-search to document.body before show,
     restore it after hide. Then position:fixed works correctly.
  ────────────────────────────────────────────────────────── */
  whenDefined('header-search', function () {

    injectCSS('mj-search-position-fix', [
      'header-search[open]{',
        'position:fixed!important;',
        'top:var(--mj-search-top, 2px)!important;',
        'left:0!important;right:0!important;',
        'width:100%!important;',
        'z-index:999!important;',
      '}',
      /* Keep header fully visible and solid when search is open */
      '.mj-search-open x-header,',
      '.mj-search-open .header{',
        'background:var(--header-background,#fff)!important;',
        'opacity:1!important;',
        'visibility:visible!important;',
        'color:var(--header-text-color,#1a1a1a)!important;',
      '}',
      /* Prevent header overlay/transparent state */
      '.mj-search-open .header.is-transparent,',
      '.mj-search-open x-header.is-transparent{',
        'background:var(--color-background,#fff)!important;',
        '--header-color:var(--header-text-color,#1a1a1a)!important;',
      '}',
    ].join(''));

    var headerSearch = document.querySelector('header-search');
    if (!headerSearch) return;

    /* Store original parent to restore after close */
    var originalParent = headerSearch.parentElement;
    var originalNextSibling = headerSearch.nextSibling;

    headerSearch.addEventListener('dialog:before-show', function () {
      /* Read --header-height CSS variable set by theme's height-observer */
      var cssVar = getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height').trim();
      var headerHeight = parseFloat(cssVar) || 2;

      /* Set top position */
      document.documentElement.style.setProperty(
        '--mj-search-top', headerHeight + 'px'
      );

      /* Set max-height */
      headerSearch.style.setProperty(
        '--header-search-max-height',
        (window.innerHeight - headerHeight) + 'px'
      );

      /* Move to body so position:fixed is relative to viewport */
      if (headerSearch.parentElement !== document.body) {
        document.body.appendChild(headerSearch);
      }

      /* Force header to stay solid/visible while search is open */
      var headerSection = document.querySelector('.shopify-section--header, [data-section-type="header"]');
      if (headerSection) headerSection.classList.add('mj-search-open');
    });

    headerSearch.addEventListener('dialog:after-hide', function () {
      /* Restore to original position in DOM */
      if (originalParent && headerSearch.parentElement === document.body) {
        if (originalNextSibling) {
          originalParent.insertBefore(headerSearch, originalNextSibling);
        } else {
          originalParent.appendChild(headerSearch);
        }
      }

      /* Restore header to normal state */
      var headerSection = document.querySelector('.shopify-section--header, [data-section-type="header"]');
      if (headerSection) headerSection.classList.remove('mj-search-open');
    });

  });

  /* ──────────────────────────────────────────────────────────
     FIX 5: SEARCHTAP FILTER HEADING DEMOTION
     SearchTap renders H3 for filter labels and H4 for the
     "Filters" title — demote to correct semantic levels.
  ────────────────────────────────────────────────────────── */
  function fixSearchTapHeadings() {
    document.querySelectorAll('h3.st-widget-title').forEach(function (h3) {
      var h4 = document.createElement('h4');
      h4.className = h3.className;
      h4.innerHTML = h3.innerHTML;
      h3.parentNode.replaceChild(h4, h3);
    });

    document.querySelectorAll('h4.filter-title').forEach(function (h4) {
      var span = document.createElement('span');
      span.className = h4.className;
      span.innerHTML = h4.innerHTML;
      h4.parentNode.replaceChild(span, h4);
    });
  }

  document.addEventListener('DOMContentLoaded', fixSearchTapHeadings);
  new MutationObserver(fixSearchTapHeadings)
    .observe(document.body, { childList: true, subtree: true });

  /* ──────────────────────────────────────────────────────────
     FUTURE OVERRIDES — add below with date + description
  ────────────────────────────────────────────────────────── */

})();
